import React from 'react';
import { CheckCircle, Search, Users, Clock, Shield } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ForEmployersPage() {
  return <div className="pt-20" data-id="element-278" data-mp="f4jfumtxhowt">
      {/* Hero */}
      <section className="bg-navy-900 text-white py-20" data-id="element-279" data-mp="f3hu9ofadk0u">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-280" data-mp="a5gcd6tljqqy">
          <div data-id="element-281" data-mp="3ikq7fuz2jvp8">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-282" data-mp="3imb01f1tp4kg">
              Find Your Next{' '}
              <span className="text-gold-500" data-id="element-283" data-mp="3dngishji7o2g">Star Employee</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8" data-id="element-284" data-mp="3skh2pyvgeeqd">
              We connect world-class companies with pre-screened, high-impact
              talent. Reduce your time-to-hire and increase retention.
            </p>
            <Button variant="gold" size="lg" href="/contact" data-id="element-285" data-mp="17rnco4ivawxi">
              Request Talent
            </Button>
          </div>
          <div className="relative" data-id="element-286" data-mp="12w851ubgdx9j">
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Office meeting" className="rounded-lg shadow-2xl" data-id="element-287" data-mp="2t9rz02hzptf2" />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-xl hidden md:block" data-id="element-288" data-mp="337y04hvz2viv">
              <div className="text-4xl font-bold text-navy-900" data-id="element-289" data-mp="3788as7upma42">95%</div>
              <div className="text-gray-600" data-id="element-290" data-mp="2ak21v8qr8vjz">Retention Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Value Props */}
      <section className="py-20 bg-white" data-id="element-291" data-mp="2jjgtwcmkle6l">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292" data-mp="2jinhav0xjugj">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-293" data-mp="2o9x7pxuaz1th">
            {[{
            icon: Clock,
            title: 'Speed',
            desc: 'Candidates presented within 48 hours.'
          }, {
            icon: Search,
            title: 'Vetting',
            desc: 'Rigorous 5-step screening process.'
          }, {
            icon: Users,
            title: 'Quality',
            desc: 'Top 1% of talent in your industry.'
          }, {
            icon: Shield,
            title: 'Guarantee',
            desc: '90-day replacement guarantee.'
          }].map((item, index) => <div key={index} className="text-center p-6 border border-gray-100 rounded-xl hover:shadow-lg transition-shadow" data-id="element-294" data-mp="2g661dzhacrlo" data-mpi={index}>
                <item.icon className="h-10 w-10 text-gold-500 mx-auto mb-4" data-id="element-295" data-mp="2p7dormi9k80z" />
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-296" data-mp="2l4r4c6nx9pdt">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-297" data-mp="4f23jd6eocrn">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-20 bg-gray-50" data-id="element-298" data-mp="7xriwbpmxnys">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-299" data-mp="7wpxbdaztj2t">
          <h2 className="text-3xl font-serif font-bold text-navy-900 mb-12" data-id="element-300" data-mp="cyf5ml6tzin7">
            Industries We Serve
          </h2>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-301" data-mp="3u7by13w5syws">
            {['Technology', 'Finance', 'Healthcare', 'Marketing', 'Engineering', 'Sales', 'Human Resources', 'Operations'].map((ind, i) => <span key={i} className="bg-white px-6 py-3 rounded-full shadow-sm text-navy-900 font-medium border border-gray-200" data-id="element-302" data-mp="gyz3xs354sax" data-mpi={i}>
                {ind}
              </span>)}
          </div>
        </div>
      </section>

      {/* Simple Contact Form for Employers */}
      <section className="py-20" data-id="element-303" data-mp="1eemov0oe8duo">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304" data-mp="1efo29bsvtcfk">
          <div className="bg-navy-900 rounded-2xl p-8 md:p-12 text-white text-center" data-id="element-305" data-mp="3mvpeq0584y7p">
            <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-306" data-mp="3hvt9jxksj0qk">
              Start Hiring Today
            </h2>
            <p className="mb-8 text-gray-300" data-id="element-307" data-mp="3cyb1e9elkpjm">
              Tell us about your open roles and we'll be in touch within 24
              hours.
            </p>
            <Button variant="gold" size="lg" href="/contact" data-id="element-308" data-mp="9gjdb63l0pqp">
              Contact Our Sales Team
            </Button>
          </div>
        </div>
      </section>
    </div>;
}